<div class="portal-page">

	<!-- Header -->
	<portal-header mode="dashboard"></portal-header>

	<!-- Tabs -->
	<div class="dash-tabs">
		<button class="portal-pill" [class.active]="tab === 'all'" (click)="tab = 'all'">
			All <span class="portal-pill-count">{{ projects.length }}</span>
		</button>
		<button class="portal-pill" [class.active]="tab === 'active'" (click)="tab = 'active'">
			Active <span class="portal-pill-count">{{ activeProjects.length }}</span>
		</button>
		<button class="portal-pill" [class.active]="tab === 'completed'" (click)="tab = 'completed'">
			Completed <span class="portal-pill-count">{{ completedProjects.length }}</span>
		</button>
		<button class="portal-pill" [class.active]="tab === 'cancelled'" (click)="tab = 'cancelled'">
			Cancelled <span class="portal-pill-count">{{ cancelledProjects.length }}</span>
		</button>
	</div>

	<!-- Cards -->
	<portal-loader *ngIf="loading"></portal-loader>
	<div class="dash-empty portal-error" *ngIf="error">{{ error }}</div>

	<p class="dash-empty" *ngIf="!loading && !error && !filtered.length">
		<ng-container *ngIf="tab === 'all'">You don't have access to any projects yet.</ng-container>
		<ng-container *ngIf="tab === 'active'">You don't have access to any active projects yet.</ng-container>
		<ng-container *ngIf="tab === 'completed'">No completed projects.</ng-container>
		<ng-container *ngIf="tab === 'cancelled'">No cancelled projects.</ng-container>
	</p>

	<div class="dash-cards" *ngIf="!loading && !error && filtered.length">
		<div class="project-card" *ngFor="let p of filtered" (click)="openProject(p)">
			<div class="card-top-line"></div>
			<div class="d-flex flex-column gap-3">
				<div class="card-title-row">
					<a class="card-name-link">
						<span class="card-name">{{ p.description || p.project_no }}</span>
						<i class="wq wq-arrow-up-right"></i>
					</a>
					<div class="d-flex align-items-center gap-1">
						<div class="status-dot"></div>
						<span class="card-status-text">{{ p.status }}</span>
					</div>
				</div>
				<div class="card-meta">
					<div>
						<div>Project</div>
						<div>{{ p.project_no }}</div>
					</div>
				</div>
			</div>
			<div class="card-photo portal-brand-fill" [class.has-image]="p.image_url">
				<img *ngIf="p.image_url" [src]="p.image_url" [ngStyle]="coverStyle(p)" alt="" />
			</div>
		</div>
	</div>

	<div class="dash-footer">
		<span>Powered by</span>
		<img class="powered-logo powered-logo-light" src="assets/img/logo/wequote-text-dark.png" alt="WeQuote" />
		<img class="powered-logo powered-logo-dark" src="assets/img/logo/wequote.svg" alt="WeQuote" />
	</div>
</div>
